import { render, staticRenderFns } from "./LoggingHistoryConfigureWrapper.vue?vue&type=template&id=3b65bc54&"
import script from "./LoggingHistoryConfigureWrapper.vue?vue&type=script&lang=ts&"
export * from "./LoggingHistoryConfigureWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports